<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalCertificate">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-pencil"></i> Assinar documento {{file.arquivo_nome}}</p>
                    <button type="button" class="close" @click="closeModal()" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <strong>
                        <required /> Arquivo que será assinado: </strong>
                    {{file.arquivo_nome}}.{{file.arquivo_extensao}}
                    <div class="row">
                        <div v-if="error" class="col-md-12">
                            <div class="alert bg-red alert-dismissible">
                                <h5><b><i class="icon fa fa-exclamation-triangle"></i></b>
                                    {{errorMessage}}</h5>
                                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                            </div>
                        </div>
                        <div v-if="!error">
                            <certificate-choice :request="request" ref="certificateChoice"></certificate-choice>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="callout callout-success">
                                <h6><b><i class="fa fa-shield"></i></b>
                                    O documento será assinado com o certificado digital selecionado.</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" @click="closeModal()" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" id="signButton" :disabled="loading || error"
                        @click="sign()" class="btn btn-success float-right"><i class="fa fa-check"></i>
                        Assinar <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import certificateChoice from './certificate-choice.vue';
    export default {
        components: {
            certificateChoice
        },
        data() {
            return {
                loading: false,
                tokenTipo: 'E',
                token: null,
                error: false,
                errorMessage: null,
                file: {
                    id: null,
                    arquivo_nome: null
                },
                request: {
                    file: null,
                    token: null,
                    certificate: null,
                },
            }
        },
        methods: {
            closeModal() {
                Object.assign(this.$data, this.$options.data());
                this.$validator.reset();
                $('#ModalCertificate').modal('toggle');
            },
            sign() {
                if (!this.request.certificate) {
                    toastr({
                        title: 'Selecione um certificado!',
                        icon: 'error'
                    });
                    return
                }
                if (this.$refs.certificateChoice.getDocument() != this.auth_user.documento && process.env
                    .NODE_ENV == 'production') {
                    toastr({
                        title: 'O certificado não pertence ao usuário logado.',
                        icon: 'warning'
                    });
                    return;
                }
                this.loading = true;
                this.prepareSign();
            },
            prepareSign() {
                this.$store.dispatch('prepareSignFile', this.file.id).then(response => {
                    this.$refs.certificateChoice.token = response.token;
                    this.error = false;
                    this.$refs.certificateChoice.sign().then(response => {
                        this.submitFile();
                    }).catch(errorSign => {
                        toastr({
                            title: errorSign,
                            icon: 'error'
                        });
                        console.log(errorSign);
                        this.loading = false;
                    });

                }).catch(error => {
                    this.error = true;
                    this.errorMessage = error.message;
                    this.loading = false;
                });
            },
            submitFile() {
                this.request.file = this.file.id;
                this.request.documento = this.$refs.certificateChoice.selectedCert.documento;
                this.request.token = this.$refs.certificateChoice.token;
                this.loading = true;
                this.$store.dispatch('signFile', this.request).then(response => {
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                    this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                    $('#ModalCertificate').modal('toggle');

                }).catch(error => {
                    toastr({
                        icon: error.status,
                        title: error.message
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>